(function () {
  'use strict';

  var EXPECTED_PROFILE_NAME = 'Chaukhat Hampers';

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function normalizeText(value) {
    return String(value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function parseRating(value) {
    var rating = Number(value);
    if (!Number.isFinite(rating)) return 5;
    return Math.max(1, Math.min(5, Math.round(rating)));
  }

  function buildStars(rating) {
    return new Array(parseRating(rating) + 1).join('★');
  }

  function isVerifiedFeed(payload, expectedSourceUrl) {
    if (
      !payload
      || !payload.source
      || normalizeText(payload.source.url) !== expectedSourceUrl
      || !Array.isArray(payload.reviews)
    ) {
      return false;
    }

    if (
      payload.placeName
      && normalizeText(payload.placeName).toLowerCase()
        !== EXPECTED_PROFILE_NAME.toLowerCase()
    ) {
      return false;
    }

    return !payload.reviews.some(function (review) {
      return normalizeText(review && review.sourceUrl) !== expectedSourceUrl;
    });
  }

  function buildCard(review, sourceUrl) {
    var text = normalizeText(review.text);
    var author = normalizeText(review.author);
    var relativeTime = normalizeText(review.relativeTime);
    var rating = parseRating(review.rating);

    return [
      '<div class="chaukhat-testimonials__card" role="listitem">',
      '  <div class="chaukhat-testimonials__quote-mark">"</div>',
      '  <div class="chaukhat-testimonials__stars" aria-label="' + rating + ' out of 5 stars">' + buildStars(rating) + '</div>',
      '  <p class="chaukhat-testimonials__review">"' + escapeHtml(text) + '"</p>',
      '  <hr class="chaukhat-testimonials__divider-hr">',
      author ? '  <p class="chaukhat-testimonials__name">— ' + escapeHtml(author) + '</p>' : '',
      relativeTime ? '  <p class="chaukhat-testimonials__meta">' + escapeHtml(relativeTime) + '</p>' : '',
      '  <a class="chaukhat-testimonials__link" href="' + escapeHtml(sourceUrl) + '" target="_blank" rel="noopener">View on Google</a>',
      '</div>',
    ].join('');
  }

  function renderTrack(section, track, reviews, sourceUrl) {
    var normalizedReviews = reviews.filter(function (review) {
      return normalizeText(review && review.text)
        && normalizeText(review && review.author);
    });

    if (!normalizedReviews.length) {
      // keep static fallback cards
      // keep static fallback cards('is-ready', 'is-animated');
      section.hidden = false;
      return;
    }

    var cardsMarkup = normalizedReviews.map(function (review) {
      return buildCard(review, sourceUrl);
    }).join('');
    var copies = normalizedReviews.length >= 3
      ? 2
      : normalizedReviews.length === 2
        ? 3
        : 5;

    track.innerHTML = new Array(copies + 1).join(cardsMarkup);
    track.classList.add('is-ready');
    track.classList.toggle('is-animated', normalizedReviews.length > 1);
    track.style.setProperty(
      '--google-review-duration',
      Math.max(24, normalizedReviews.length * 8) + 's',
    );
    section.hidden = false;
  }

  async function loadReviews(section) {
    var track = section.querySelector('[data-google-reviews-track]');
    if (!track) return;

    var feedUrl = section.getAttribute('data-feed-url');
    var sourceUrl = normalizeText(section.getAttribute('data-source-url'));
    var reviews = [];

    if (feedUrl && sourceUrl) {
      try {
        var response = await fetch(feedUrl, {
          credentials: 'same-origin',
          cache: 'no-store',
        });
        if (response.ok) {
          var payload = await response.json();
          if (isVerifiedFeed(payload, sourceUrl)) {
            reviews = payload.reviews;
          } else {
            console.warn('Google reviews feed identity validation failed.');
          }
        }
      } catch (error) {
        console.warn('Google reviews feed fetch failed.', error);
      }
    }

    renderTrack(section, track, reviews, sourceUrl);
  }

  function initGoogleReviewsMarquee() {
    var sections = document.querySelectorAll('[data-google-reviews-marquee]');
    Array.prototype.forEach.call(sections, loadReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGoogleReviewsMarquee);
  } else {
    initGoogleReviewsMarquee();
  }
})();
